
<template>
    <page>
        <module title="操作指南" enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="标题">
                    <c-input name="name" placeholder="请输入搜索关键字"></c-input>
                </m-search-item>
            </m-search>

            <div class="guideInfo">
                <div v-for="(item,index) in list" :key="item.id" class="guide-card"  @click="goToDetail(item)">
                    <c-file media :src="item.video_url||item.img_url" class="guide-file" :preview="false"></c-file>
                    <div class="guide-title">{{item.name}}</div>
                </div>
                <div v-if="list.length==0" style="width:100%;height:800px;">
                    <Empty type="guide"></Empty>
                </div>
            </div>

        </module>
        <pagination
                ref="pagination"
                :total="total"
                :border="true"
                @handle="searchHandle"
                :size="10">
        </pagination>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import MSearchItem from "@/components/module/search_item.vue";
export default {
    name: 'm_operation_guide',
    components: {
        MSearchItem,
        Pagination: () => import('@/submodule/components/public/pagination'),
        Empty: () => import('@/submodule/components/public/empty'),
    },

    props: {
        tab: String
    },

    data() {
        return {
            list: [],
            total: 0,
            currentPage: 1,
        }
    },

    computed: {
        ...mapState(['userInfo']),
    },

    mounted() {
        this.$refs.search.search();
    },

    methods: {
        searchHandle(data) {
            // 操作指南 固定传参
            data.type_id = -1;
            data.state = [2];
            this.request({
                url: '/abstract_consultation/list',
                data: {
                    ...data,
                    pageIndex: data.pageIndex || 1,
                    pageSize: data.pageSize || 10
                },
                loading: true,
                success: (obj) => {
                    this.list = obj;
                },
                response: res => {
                    this.total = res.total;
                }
            })
        },
        goToDetail(item) {
            this.$router.push(`/help_detail/${item.id}`);
            //this.navigateTo(`/help_detail/${item.id}`);
        }
    }
}
</script>

<style scoped>
.guideInfo{
    display: flex;
    flex-wrap: wrap;
}
.guide-title {
    text-align: left;
    height: 40px;
    padding: 10px 20px;
    background-color: #F5F5F5;
    font-weight: 600;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
}
.guide-card {
    width: 300px;
    margin: 20px;
    cursor: pointer;
}
.guide-file {
    width:300px;
    height:180px;
    border: none;
}
</style>